"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPartner = void 0;
var PreludeCard_1 = require("../prelude/PreludeCard");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var SelectCard_1 = require("../../inputs/SelectCard");
var NewPartner = (function (_super) {
    __extends(NewPartner, _super);
    function NewPartner() {
        return _super.call(this, {
            name: CardName_1.CardName.NEW_PARTNER,
            metadata: {
                cardNumber: 'P43',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(1); }).prelude().asterix();
                }),
                description: 'Raise your M€ production 1 step. Immediately draw 2 prelude cards. Play 1 of them, and discard the other.',
            },
        }) || this;
    }
    NewPartner.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        var cardsDrawn = [
            player.game.dealer.dealPreludeCard(),
            player.game.dealer.dealPreludeCard(),
        ];
        player.game.log('You drew ${0} and ${1}', function (b) { return b.card(cardsDrawn[0]).card(cardsDrawn[1]); }, { reservedFor: player });
        var playableCards = cardsDrawn.filter(function (card) { return card.canPlay(player); });
        if (playableCards.length === 0) {
            player.game.log('${0} and ${1} were discarded as ${2} could not pay for both cards.', function (b) { return b.card(cardsDrawn[0]).card(cardsDrawn[1]).player(player); });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Choose prelude card to play', 'Play', playableCards, function (foundCards) {
            if (foundCards[0].canPlay === undefined || foundCards[0].canPlay(player)) {
                return player.playCard(foundCards[0]);
            }
            else {
                throw new Error('You cannot pay for this card');
            }
        }, 1, 1);
    };
    return NewPartner;
}(PreludeCard_1.PreludeCard));
exports.NewPartner = NewPartner;
//# sourceMappingURL=NewPartner.js.map